import { requestGet } from '@/common/request';

export interface dailyActPermissionParams {
  roomId: string;
}

export interface dailyActPermissionRes {
  ret: string;
  msg: string;
  data: any;
}

//日常活动 - 日常活动角色及模块可见性
export async function dailyActPermission(params: dailyActPermissionParams): Promise<dailyActPermissionRes> {
  return await requestGet('/room/dailyActPermission', params);
}
